import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { useSettingEnableHomepagePrefetching } from "@faire/retailer-visitor-shared/settings/useSettingEnableHomepagePrefetching";
import { useAssignSettingEnableHomepagePrefetching } from "@faire/retailer-visitor-shared/settings/useSettingEnableHomepagePrefetching";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import { useCallback } from "react";

export const useHomepagePrefetchOnHover = () => {
  const { prefetch } = useNextRouterContext();
  const isEnabledHomePagePrefetching = useSettingEnableHomepagePrefetching();

  const prefetchHandler = useCallback(() => {
    prefetch(home(), {
      kind: PrefetchKind.FULL,
    });
  }, [prefetch]);

  if (!isEnabledHomePagePrefetching) {
    return undefined;
  }

  return prefetchHandler;
};

export const useAssignSettingHomepagePrefetchingOnClick = () => {
  const assignSettingEnableHomepagePrefetching =
    useAssignSettingEnableHomepagePrefetching();

  const handleOnClick = useCallback(() => {
    assignSettingEnableHomepagePrefetching();
  }, [assignSettingEnableHomepagePrefetching]);

  return handleOnClick;
};
